<!--
 * @Description: 设备管理-控开设备
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: Wang Xiaowu (wangxiaowu@example.com)
 * @Date: 2021-10-14 18:04:03
 * @LastEditTime: 2023-05-26 13:38:35
-->
<template>
<div class="ControlDevice">
  <!-- <div class="GatewayChildren" v-if="showChild">
    <gateway-child :deviceId="deviceId" @jumpDevice="jumpDevice"></gateway-child>
  </div>
  <div class="navShow" v-if="!showChild">
    <i><img src="../../assets/img/setIcon.png" alt=""></i>
    <h3 v-if="JSON.stringify(tabData) == '{}'">设备列表</h3>
    <el-breadcrumb separator=">">
      <template v-if="JSON.stringify(tabData) != '{}'">
        <el-breadcrumb-item :to="{ path: '/gateway' }">
          <span @click="jumpDev">设备列表</span>
        </el-breadcrumb-item>
        <template>
          <el-breadcrumb-item>{{tabData.name}}</el-breadcrumb-item>
        </template>
      </template>
    </el-breadcrumb>
  </div> -->
  <div class="devcieContainer" :style="styleObject" v-if="JSON.stringify(tabData) == '{}'&&!showChild">
    <!-- 左侧组织 -->
    <div class="treeAside">
      <div class="treeTop">
        <span class="treeTopTitle">区域</span>
      </div>
      <div class="treeBox">
        <el-tree
          lazy
          :load="loadData"
          :props="props"
          v-if="1"
          class="tree"
          ref="tree"
          :indent="6"
          node-key="value"
          highlight-current
          :expand-on-click-node="false"
          @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree>
        <!-- <el-tree v-if="1" class="tree" :indent=6 :data="treeData" how-checkbox node-key="value" default-expand-all highlight-current :expand-on-click-node="false" @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree> -->
      </div>
    </div>

    <div class="container">
      <div class="query">
        <div class="queryCons">
          <div class="common">
            <el-input placeholder="设备名称/设备类型/IMEI" autocomplete="off" v-model="searchText"></el-input>
            <div class="search" @click="serachData">
              <i><img src="../../assets/img/searchIcon.png" alt=""></i>
            </div>
          </div>
          <el-select class="common" v-model="keyWords.isInstall" placeholder="是否安装" clearable @change="isInstallChange">
            <el-option label="已安装" :value="1"></el-option>
            <el-option label="未安装" :value="0"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isRegist" placeholder="是否注册" clearable @change="isRegistChange">
            <el-option label="已注册" :value="1"></el-option>
            <el-option label="未注册" :value="0"></el-option>
          </el-select>
          <!-- <el-select class="common" v-model="keyWords.isOnline" placeholder="是否在线" clearable @change="isOnlineChange">
            <el-option label="在线" :value="true"></el-option>
            <el-option label="离线" :value="false"></el-option>
          </el-select> -->
          <!-- <el-select class="common" v-model="keyWords.typeId" placeholder="设备类型" clearable>
            <el-option v-for="(item,i) in deviceTypeList" :key="i" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
          <el-select class="common" v-model="keyWords.isAlarm" placeholder="是否报警" clearable @change="isAlarmChange">
            <el-option label="报警" :value="true"></el-option>
            <el-option label="未报警" :value="false"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isFault" placeholder="是否故障" clearable @change="isFaultChange">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
          <!-- <button class="primaryBtn common" @click="serachData">搜索</button> -->
          <el-button class="delSome" type="primary" size="medium" @click="changeRightCons" icon="el-icon-s-data">实时统计</el-button>
          <!-- <button class="delSome" @click="changeRightCons">
            <i class="imgShow"><img src="../../assets/img/statistics.png" alt=""></i>
            <span>实时统计</span>
          </button> -->
        </div>
      </div>
      <div class="listsContainer" :style="styleObjectCons">
        <div class="listsLeft">
          <el-scrollbar wrap-class="scrollbar-wrapper" v-loading="tableLoading">
            <ul class="clearfix device-cardList">
              <li :class="['device-card', item.isOnline == '离线' ? 'out-card' : '']" v-for="(item,index) in dataList" :key="index">
                <!-- <div class="meng-ban" v-if="item.pwrstate == 'false'"></div> -->
                <!-- <div class="meng-ban" v-if="item.isOnline == '离线'"></div> -->
                <h6>
                  <img src="../../assets/img/devicetype/elect-gray.png" v-if="item.isOnline == '离线'">
                  <img src="../../assets/img/devicetype/elect.png" v-else>
                  <span class="title overText">市电</span>
                  <span class="u1">{{item.u1value}}V</span>
                  <div class="title-right">
                    <!-- <p class="sign"> -->
                    <span class="sign-num" v-if="item.isOnline != '离线'">{{item.csq}}%</span>
                    <img class="sign" src="../../assets/img/bigScreen/sign-0.png" alt="" v-if="item.isOnline == '离线'">
                    <img class="sign" :src="signImg(item.sign)" alt="" v-else>
                    <span class="electric" @click="handleSet(item)">
                      <i class="el-icon-s-tools"></i>
                    </span>
                  </div>
                </h6>
                <div class="chart-item">
                  <div class="name">
                    <span v-show="!item.isEdit" class="name-text" @dblclick="handleEdit(index)">{{item.name}}</span>
                    <el-input v-show="item.isEdit" v-model="item.nameTemp" placeholder="请输入设备名称" maxlength="15" @blur="handleBlur(index)"></el-input>
                    <!-- <i class="el-icon-edit-outline" @click="handleEdit"></i> -->
                    <!-- <div class="is-online"><el-tag size="mini" :type="(item.pwrstate=='true' || item.pwrstate=='1') ? 'success' : 'info'">{{(item.pwrstate=='true' || item.pwrstate=='1') ? '在线' : '离线'}}</el-tag></div> -->
                    <div class="is-online"><el-tag size="mini" :type="item.isOnline=='在线' ? 'success' : 'info'">{{item.isOnline}}</el-tag></div>
                  </div>
                  <div class="icon-left">
                    <img src="../../assets/img/devicetype/kk.png" alt="">
                  </div>
                  <!-- <div class="chart">
                    <div
                      class="child-item"
                      v-for="(cItem, i) in item.child"
                      :style="{
                        color: cItem.s == 1 ? '#EB2D2E' : cItem.o == 'true' ? '#16D585' : '#bbb',
                        borderColor: cItem.s == 1 ? '#EB2D2E' : cItem.o == 'true' ? '#16D585' : '#bbb'
                      }"
                      :key="i">
                      <i :style="{ borderColor: cItem.s == 1 ? '#EB2D2E' : cItem.o == 'true' ? '#16D585' : '#bbb' }">{{cItem.i}}</i>
                      <p class="An">{{cItem.a || '--'}}<span>A</span></p>
                      <p>{{cItem.n || '--'}}</p>
                    </div>
                  </div> -->
                  
                  <div class="device-params">
                    <div>
                        <p class="params-t">IMEI</p>
                        <el-tooltip effect="light" :content="item.imei1" placement="top">
                          <p class='overText' >{{item.imei1 || '--'}}</p>
                        </el-tooltip>
                    </div>
                    <div>
                        <p class="params-t">设备ID</p>
                        <el-tooltip effect="light" :content="item.unicomDeviceKey" placement="top">
                          <p class='overText' >{{item.unicomDeviceKey || '--'}}</p>
                        </el-tooltip>
                    </div>
                    <div>
                      <p class="params-t">ICCID</p>
                      <el-tooltip effect="light" :content="item.iccid" placement="top">
                        <p class='overText'>{{item.iccid || '--'}}</p>
                      </el-tooltip>
                    </div>
                    <div>
                      <p class="params-t">工作模式</p>
                      <p class="time-t">{{item.workmode == 0 ? '点动' : item.workmode == 1 ? '自锁' : item.workmode == 2 ? '互锁' : '--'}}</p>
                    </div>
                    <div>
                      <p class="params-t">安装位置</p>
                      <p class="time-t">{{item.installLocation || '--'}}</p>
                    </div>
                  </div>
                </div>

                <div class="card-bottom">
                  <img src="../../assets/img/devicetype/line-num-gray.png" alt="" v-if="item.isOnline == '离线'">
                  <img src="../../assets/img/devicetype/line-num.png" alt="" v-else>
                  线路数
                  <span>{{item.child.length}}</span>
                  <ul>
                    <li v-for="(circle, i) in item.child" :key="i">

                      <span :style="{backgroundColor: circle.s == 1 ? '#EB2D2E' : circle.o == 'true' ? '#16D585' : '#bbb'}"></span>

                      <p :style="{ borderColor: circle.s == 1 ? '#EB2D2E' : circle.o == 'true' ? '#16D585' : '#bbb', color: circle.s == 1 ? '#EB2D2E' : circle.o == 'true' ? '#16D585' : '#bbb' }">{{circle.i}}</p>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </el-scrollbar>
          <div class="noData" v-if="!(dataList&&dataList.length)&&consShow">
            <img src="../../assets/img/noData.png" alt="">
            <div class="tip">暂无数据</div>
          </div>
          <div class="cardPage">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.currentPage" :page-sizes="pagination.pageSizes" :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="maskingRight" v-if="changeStatus&&!showChild">
    <div class="listsRight" :class="showSlid?'component-slid-open' : 'component-slid-out'">
      <div class="messContainer">
        <div class="cons">
          <device-right-cons :typeId="11" @closeRightCons="closeRightCons"></device-right-cons>
        </div>
      </div>
    </div>
  </div>
  <div class="mainContent" :style="styleObject" v-if="JSON.stringify(tabData) != '{}'&&!showChild">
    <div class="tabBox">
      <tab-block @tabToggle="toggleCom" :pageType="pageType" :tabs="tabs"></tab-block>
    </div>
    <div class="main">
      <component :is="component" :deviceId="deviceId" :deviceImei="deviceImei"></component>
    </div>
  </div>

  <!-- 空开设置弹框 -->
  <el-drawer title="设置" size="650px" :modal="false" :visible.sync="datailsShow" :wrapperClosable="false" direction="rtl" ref="drawer">
    <el-empty description="暂无数据" v-if="!setLoading && childList.length<=0"></el-empty>
    <ul class="dialog-box" v-loading="setLoading" v-else>
      <li v-for="(child, i) in childList" :key="i">
        <h6 @click="handleOpenEdit(child)">
          <img src="../../assets/img/devicetype/line-num.png" alt="">
          {{ child.i || '--' }}路
          <i class="el-icon-edit-outline edit-icon"></i>
        </h6>
        <div class="eye-switch">
          <p class="action-box">
            <i class="el-icon-view" :style="{ color: child.w == 1 ? '#1890FF':'#bbb'}" :title="child.w ? actionOptions[child.w].label: ''" v-if="child.w!=2"></i>
            <img class="eye" src="../../assets/img/bigScreen/eye.png" :title="child.w ? actionOptions[child.w].label: ''" alt="" v-else>
          </p>
          <div class="switch-box" title="开启/闭合 线路">
            <el-switch
              v-model="child.open"
              @change="handleChangeAlarm($event, child)"
              active-color="#1890FF"
              inactive-color="#bbb"
              active-text="on"
              inactive-text="off">
            </el-switch>
            <!-- <span class="switch-text">{{ child.o == false ? 'off' : 'on' }}</span> -->
          </div>
        </div>
        <div class="set-bottom" :style="{color: child.s == 1 ? '#EB2D2E' : child.o == 'true' ? '#16D585' : '#bbb'}">
          <h4>电流</h4>
          <p class='a-box'>{{ child.a || '--' }}<span>A</span></p>
          <p>{{ child.n || '--'}}</p>
        </div>
      </li>
    </ul>
  </el-drawer>

  <el-dialog title="编辑详情" :visible.sync="dialogVisible" width="440px">
    <ul class="edit-dialog">
      <li>
        <span class="title">名称</span>
        <el-input placeholder="请输入名称" v-model="editData.name" clearable maxlength="10">
        </el-input>
      </li>
      <li>
        <span class="title">报警条件</span>
        <div class="alarm-va">
          <p>
            <el-checkbox v-model="editData.checkedV">电压 </el-checkbox>
            <span class="equal">≥</span>
            <el-input-number v-model="editData.yv" :min="0" :max="260"></el-input-number> V
          </p>
          <p>
            <el-checkbox v-model="editData.checkedA">电流 </el-checkbox>
            <span class="equal">≥</span>
            <el-input-number v-model="editData.ya" :min="0" :max="30"></el-input-number> A
          </p>
        </div>
      </li>
      <li>
        <span class="title">执行动作</span>
        <el-select v-model="editData.w" placeholder="请选择">
          <el-option
            v-for="({value, label}, i) in actionOptions"
            :key="i"
            :label="label"
            :value="value">
          </el-option>
        </el-select>
      </li>
    </ul>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSave">保 存</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import TabBlock from '@/components/common/TabBlock'
import BasicInfo from '@/views/deviceManagement/gatewayChild/BasicInfo'
import DeviceDatas from '@/views/deviceManagement/deviceDetails/DeviceDatas'
import IssueCommand from '@/views/deviceManagement/deviceDetails/IssueCommand'
import AlarmRecord from '@/views/deviceManagement/deviceDetails/AlarmRecord'
import FaultRecord from '@/views/deviceManagement/deviceDetails/FaultRecord'
import InstallRecord from '@/views/deviceManagement/deviceDetails/InstallRecord'
import DeviceRightCons from '@/views/deviceManagement/gatewayChild/DeviceRightCons'
import GatewayChild from '@/views/deviceManagement/gatewayChild/GatewayChild'
export default {
  name: 'ControlDevice',
  components: {
    TabBlock,
    BasicInfo,
    DeviceDatas,
    IssueCommand,
    AlarmRecord,
    FaultRecord,
    InstallRecord,
    DeviceRightCons,
    GatewayChild
  },
  data() {
    return {
      treeData: [],
      searchText: '',
      keyWords: {
        isAlarm: "",
        isFault: "",
        isInstall: "",
        isOnline: "",
        isRegist: "",
        typeId: ''
      },
      options: [{
        value: '1',
        label: '在线'
      }, {
        value: '0',
        label: '离线'
      }],
      actionOptions: [
        { value: '0', label: '执行关闭' },
        { value: '1', label: '执行开启' },
        { value: '2', label: '只报警' },
      ],
      component: '',
      tabs: [{
          name: '基本信息',
          code: 'BasicInfo'
        }, {
          name: '设备数据',
          code: 'DeviceDatas'
        },
        // {
        //   name: '下发命令',
        //   code: 'IssueCommand'
        // },
        {
          name: '报警记录',
          code: 'AlarmRecord'
        }, {
          name: '故障记录',
          code: 'FaultRecord'
        }, {
          name: '安装记录',
          code: 'InstallRecord'
        }
      ],
      pageType: 'DeviceGas',
      styleObject: {
        height: ''
      },
      styleObjectCons: {
        height: ''
      },
      tabData: {},
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 12,
        pageSizes: [12, 22, 32],
        total: 0
      },
      dataList: [],
      deviceTypeList: [],
      tableLoading: true,
      deviceId: null,
      getEchartStatus: '',
      deviceImei: '',
      changeStatus: false,
      consShow: false,
      currentTreeId: '',
      showSlid: false,
      showChild: false,
      datailsShow: false,
      dialogVisible: false,
      childList: [],
      editData: {
        name: '',
        ya: '',
        yv: '',
        w: '',
        checkedV: false,
        checkedA: false,
      },
      editId: null,
      setLoading: false,
      isEdit: false,
      props: {
        label: 'label',
        children: 'children',
        isLeaf: 'isLeaf'
      }
    }
  },
  computed: {
    signImg() {
      return (n) => {
        return require(`../../assets/img/bigScreen/sign-${n}.png`)
      }
    }
  },
  created() {
    this.makeheight()
    this.makeheightCons()
    // this.queryTreeNode()
    // this.dataList = [{}, {}, {}, {}, {}]
    this.initData()
    this.getDeviceType()
  },
  methods: {
    jumpDevice(val){
      this.showChild = val
    },
    showLabel(label) {
      if (!label) {
        return label;
      }
      return label;
    },
    // 查询组织
    queryTreeNode(pid = 0) {
      this.request.get(`/front/device/region/findTreeById?id=${pid}`)
        .then(rs => {
          // console.log(rs);
          this.treeData = rs.code === 200 ? rs.data : [];
          this.currentTreeId = this.treeData.length > 0 ? this.treeData[0].value : 0;
        })
        .catch(error => (this.treeData = []));
    },
    // 查询区域
    loadData (node, resolve) {
      if (node.level === 0) {
        let root = { id: 0, label: '区域机构', parentId: 0, value: 0 }

        //默认展开第一层根节点---节点渲染完成后，加载第二层节点的核心代码
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(0)
          let nodedata = node.childNodes[0];
          nodedata.expanded = true;
          nodedata.loadData();
        })
        resolve([root])
      } else {
        let pid = node.data ? node.data.id : 0

        this.request.get(`/front/device/region/findTreefenjiById?id=${pid}`).then(rs => {
          let data = rs.code === 200 ? rs.data : []

          // 区域-终端出库设备
          if (node.level == 1) {
            data.unshift({ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true })
          }

          resolve(data)
        }).catch(error => {
          console.error(error)
          let temp = node.level == 1 ? [{ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true }] : []
          resolve(temp)
          // resolve([])
        })        
      }
    },    
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      this.currentTreeId = item ? (item.value ? item.value : 0) : 0;
      this.pagination.currentPage = 1;
      this.initData();
    },
    getDeviceType() {
      this.request.post('/front/device/type/query', {
          page: 1,
          pageSize: 1000
        }).then(res => {
          if (res.code === 200) {
            this.deviceTypeList = res.data.data ? res.data.data : []
          } else if (res.code === 500) {
            this.deviceTypeList = []
            this.msg.warn(res.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    serachData() {
      //查询//搜索
      this.getEchartStatus = this.keyWords.typeId
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1
      this.initData()
    },
    initData() {
      this.consShow = false
      this.params = {
        key: this.searchText,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        orgId: this.currentTreeId ? this.currentTreeId : this.storage.getSession("orgId"),
        typeId: this.keyWords.typeId,
        isInstall: this.keyWords.isInstall,
        isAlarm: this.keyWords.isAlarm,
        isFault: this.keyWords.isFault,
        isRegist: this.keyWords.isRegist,
        isOnline: this.keyWords.isOnline,
      }

      let url = this.params.orgId == -1 ? '/front/device/smartopen/queryOutbound' : '/front/device/smartopen/query'
      this.request.get(url, this.params)
        .then(res => {
          if (res.code === 200) {
            this.tableLoading = false
            this.consShow = true

            this.pagination.total = res.total
            this.dataList = res.data && res.data.map(item => {
              let ivalue = item.ivalue ? JSON.parse(item.ivalue) : {}
              let child = []

              for (const [key, val] of Object.entries(ivalue)) {
                let value = JSON.parse(val)
                if (value) {
                  // console.log(value.o)
                  value.i = key.substr(3)
                  child.push(value)
                }
              }

              item.child = child
              item.isEdit = false
              item.nameTemp = item.name

              // 计算信号
              if (item.csq > 0 && item.csq <= 25) {
                item.sign = 1
              } else if (item.csq > 25 && item.csq <= 50) {
                item.sign = 2
              } else if (item.csq > 50 && item.csq <= 75) {
                item.sign = 3
              } else if (item.csq > 75 && item.csq <= 100) {
                item.sign = 4
              } else {
                item.sign = 0
              }
              return item
            })
          } else if (res.code === 500) {
            this.dataList = []
            this.msg.warn(res.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    jumpDev() {
      this.tabData = {}
    },
    toggleCom(tabCode) {
      // console.log(tabCode);
      this.tabData = tabCode
      this.component = tabCode.code
    },
    clickEven(val) {
      console.log(val);
      this.tabData = {
        name: '基本信息',
        code: 'BasicInfo'
      }
      this.deviceId = val.deviceId
      this.deviceImei = val.imei
    },
    clickEvenChild(val) {
      console.log(val);
      this.deviceId = val.deviceId
      this.showChild = true
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和makeheightCons
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    makeheightCons(height = 220) {
      let _this = this;
      _this.styleObjectCons.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObjectCons.height = window.innerHeight - height + "px";
        })();
      };
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.initData()
    },
    handleSizeChange(val) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = val
      this.initData()
    },
    changeRightCons() {
      if (!this.changeStatus) {
        this.changeStatus = true
        this.showSlid = true
      } else {
        this.showSlid = false
        setTimeout(() => {
          this.changeStatus = this.showSlid
        }, 440)
      }
    },
    closeRightCons(data){
      this.showSlid = false
        setTimeout(() => {
          this.changeStatus = data
        }, 440)
    },
    isInstallChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isRegistChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isOnlineChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isAlarmChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isFaultChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    /**
     * @Description 卡片点击设置
     * @Author      YOYO     -             2021-11-27
     * @return      {[type]} [description]
     */
    handleSet (item) {
      if (item.isOnline == '离线') return this.$message({ type: 'warning', message: '离线状态下不允许操作设备' })
      this.datailsShow = true
      // this.childList = item.child
      this.editId = item.deviceId
      this.getDeviceDetails(item.deviceId)
    },
    /**
     * @Description 编辑name
     * @Author      YOYO     -             2021-11-27
     * @return      {[type]} [description]
     */
    handleEdit (i) {
      let dataList = [...this.dataList]
      dataList[i].isEdit = true
      this.dataList = dataList
    },
    /**
     * @Description 编辑name
     * @Author      YOYO     -             2021-11-27
     * @return      {[type]} [description]
     */
    handleBlur (i) {
      let dataList = [...this.dataList]

      let nameTemp = dataList[i].nameTemp
      let name = dataList[i].name
      let id = dataList[i].deviceId

      if (!(nameTemp.replace(/(^\s*)|(\s*$)/g, ''))) {
        return this.$message({ type: 'warning', message: '设备名称不能为空！' })
      }

      this.request.get(`/front/device/smartopen/upname?name=${nameTemp}&id=${id}`).then(res => {
        if (res.code == 200) {
          dataList[i].isEdit = false
          this.dataList = dataList
          this.initData()
          this.$message({ type: 'success', message: '修改设备名称成功！' })
        } else {
          dataList[i].nameTemp = name
          this.dataList = dataList
          this.$message({ type: 'warning', message: res.msg })
        }
      }).catch(e => {
          dataList[i].nameTemp = name
          this.dataList = dataList
          this.$message({ type: 'error', message: '网络异常，请稍后再试' })
      })
    },
    /**
     * @Description 获取详情信息
     * @Author      YOYO     -  2021-11-27
     * @param       {[type]} id [description]
     * @return      返回详情信息
     */
    getDeviceDetails(id) {
      this.setLoading = true
      this.request.get(`front/device/smartopen/${id}`).then(res => {
        this.setLoading = false
        if (res.code == 200) {
          let data = res.data
          let ivalue = JSON.parse(data.ivalue)
          let child = []

          for (const [key, val] of Object.entries(ivalue)) {
            let value = JSON.parse(val)
            if (value) {
              value.i = key.substr(3)
              value.open = value.o == 'true'
              child.push(value)
            }
          }
          this.childList = child
        } else {
          this.$message({ type: 'warning', message: res.msg })
        }
      }).catch(e => {
        console.log(e)
        this.setLoading = false
      })
    },
    /**
     * @Description 设置里的卡片点击编辑
     * @Author      YOYO     -             2021-11-27
     * @return      {[type]} [description]
     */
    handleOpenEdit (item) {
      let { n, w, yv, ya, i } = item
      this.dialogVisible = true
      this.editData = {
        name: n || '',
        ya: (ya == null || ya == 'null' || ya == 'undefined') ? 1 : ya,
        yv: (yv == null || yv == 'null' || yv == 'undefined') ? 220 : yv,
        w,
        checkedV: yv ? true : false,
        checkedA: ya ? true : false,
        i
      }
    },
    /**
     * @Description 设置里的卡片点击编辑
     * @Author      YOYO     -             2021-11-27
     * @return      {[type]} [description]
     */
    handleSave () {
      let { name, ya, yv, w, i, checkedV, checkedA } = this.editData

      this.request.get(`/front/device/smartopen/upOne?name=${name}&ya=${checkedA ? ya:''}&yv=${checkedV ? yv:''}&w=${w}&num=${i}&id=${this.editId}`).then(res => {
        if (res.code == 200) {
          this.dialogVisible = false
          this.initData()
          this.getDeviceDetails(this.editId)
          this.$message({ type: 'success', message: '保存成功' })
        } else {
          this.$message({ type: 'warning', message: res.msg })
        }
      }).catch(e => {
        this.$message({ type: 'error', message: e })
      })
    },
    /**
     * @Description 是否报警
     * @Author      YOYO     - 2021-11-27
     * @param       {boolean} e [description]
     */
    handleChangeAlarm (e, { i }) {
      this.request.get(`/front/device/smartopen/perform?o=${e}&num=do${i}s&id=${this.editId}`).then(res => {
        if (res.code == 200) {
          this.initData()
          this.getDeviceDetails(this.editId)
          this.$message({ type: 'success', message: '操作成功' })
        } else {
          this.$message({ type: 'warning', message: res.msg })
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.ControlDevice {
  // position: relative;

  .navShow {
    margin-left: 20px;
    overflow: hidden;
    padding-bottom: 8px;
    border-bottom: 1px solid #f2f2f2;

    i {
      float: left;
      width: 16px;
      height: 16px;
      margin-right: 4px;

      img {
        width: 100%;
        height: 100%;
        vertical-align: unset;
      }
    }

    h3 {
      float: left;
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
      color: #7A7D81;
    }

    span {
      float: left;
      font-size: 16px;
      font-weight: 500;
      color: #7A7D81;
    }
  }

  .devcieContainer {
    margin: 10px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    h4 {
      padding-bottom: 10px;
    }

    .container {
      padding: 0 10px 0 300px;
    }

    .query {
      padding-bottom: 10px;

      .queryCons {
        width: 100%;
        overflow: hidden;

        .common {
          float: left;
          margin-bottom: 5px;
          position: relative;
          .search{
            position: absolute;
            right: 10px;
            top: 0px;
            width: 40px;
            height: 40px;
            font-size: 0;
            z-index: 10;
            text-align: center;
            cursor: pointer;
            i{
              display: inline-block;
              width: 16px;
              height: 16px;
              cursor: pointer;
              margin-top: 12px;
              img{
                width: 100%;
                height: 100%;
              }
            }
          }
        }

        .primaryBtn {
          width: 82px;
          height: 40px;
          cursor: pointer;
          margin-right: 20px;
          font-size: 14px;
          line-height: 40px;
          border: 0;
          color: #FFFFFF;
          background: #1089FF;
          border-radius: 2px;

          &:hover {
            background: #0774e0;
          }
        }

        .delSome {
          // width: 102px;
          // cursor: pointer;
          float: right;
          // font-size: 0;
          // padding: 0 10px;
          // border: 0;
          // color: #FFFFFF;
          // background: #1089FF;
          // border-radius: 2px;
          // outline: unset;
          // overflow: hidden;

          // &:hover {
          //   background: #0774e0;
          // }

          // .imgShow {
          //   float: left;
          //   width: 16px;
          //   height: 16px;
          //   margin: 10px 6px 0 0;

          //   img {
          //     width: 100%;
          //     height: 100%;
          //     vertical-align: middle;
          //   }

          //   &.active {
          //     transform: rotate(180deg);
          //   }
          // }

          // span {
          //   float: left;
          //   font-size: 14px;
          //   line-height: 40px;
          // }
        }
      }
    }

    .listsContainer {
      overflow: hidden;
      position: relative;
      background-color: #f2f2f2;

      .listsLeft {
        float: left;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 0 45px;
        position: relative;

        // background: #f3f3f3;
        .noData {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -150px;
          margin-top: -150px;
          text-align: center;

          img {
            width: 300px;
            height: 300px;
          }

          .tip {
            margin-top: 10px;
            font-size: 18px;
            color: #bbb;
          }
        }

        .device-cardList {
          width: 100%;
          height: 100%;
          overflow-x: hidden;
          overflow-y: auto;
          font-size: 14px;
          .device-card {
            display: inline-block;
            border: 1px solid #E1E1E1;
            background: #fff;
            width: 308px;
            height: 320px;
            padding: 5px 10px;
            // margin-bottom: 10px;
            // margin-right: 5px;
            // margin-left: 5px;
            margin: 5px;
            position: relative;
            border-radius: 4px;
            box-shadow: 0px 0px 30px 5px rgba(220,236,248, 0.4);
            .meng-ban {
              position: absolute;
              width: 328px;
              height: 300px;
              top: 0;
              left: 0;
              background-color: rgba(225, 225, 225, .5);
              z-index: 9;
            }
            h6 {
              height: 28px;
              line-height: 28px;
              border-bottom: 1px solid #E1E1E1;
              .title {
                font-size: 16px;
                color: #000;
                display: inline-block;
                // width: 300px;
                vertical-align: top;
                margin-left: 5px;
              }
              .u1 {
                border: 1px solid #1890FF;
                color: #1890FF;
                font-size: 12px;
                padding: 0px 10px;
                border-radius: 3px;
                margin-left: 10px;
              }
              .title-right {
                font-size: 12px;
                float: right;
                color: #178FFD;
                margin-top: -2px;
                position: relative;
                z-index: 2;

                .sign {
                  // border: 1px solid red;
                  // display: inline-block;
                  margin-right: 2px;
                  vertical-align: 2px;
                  width: 16px;
                  // height: 14px;
                  // img {
                    // width: 16px;
                  // }
                  // background: url(../../assets/img/bigScreen/sign-0.png) no-repeat;
                  // background-size: 16px 14px;
                  // span{
                  //   display: inline-block;
                  //   height: 12px;
                  //   width: 2px;
                  //   background-color: #178FFD;
                  //   margin-left: 1.5px;
                  //   vertical-align: 4.5px;
                  //   &:nth-child(1) {
                  //     height: 4px;
                  //   }
                  //   &:nth-child(2) {
                  //     height: 6px;
                  //   }
                  //   &:nth-child(3) {
                  //     height: 8px;
                  //   }
                  //   &:nth-child(4) {
                  //     height: 10px;
                  //   }
                  // }
                }
                .sign-num {
                  margin-right: 5px;
                  vertical-align: 2px;
                  // margin-right: 10px;
                  // position: absolute;
                  // font-size: 10px;
                  // top: -8px;
                  // right: 23px;
                }
                .electric {
                  font-size: 20px;
                  cursor: pointer;
                }
              }
            }
            .chart-item {
              overflow: hidden;
              height: 260px;
              width: 100%;
              .name {
                margin: 10px 0;
                .name-text {
                  position: relative;
                  display: inline-block;
                  vertical-align: -1px;
                  max-width: 270px;
                  font-size: 15px;
                  font-weight: bold;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  cursor: pointer;
                  z-index: 10;
                }
                .el-input {
                  position: relative;
                  z-index: 10;
                  width: 200px;
                }
                >i {
                  cursor: pointer;
                  color: #178FFD;
                  font-size: 20px;
                }
                .is-online {
                  float: right;
                }
              }
              .icon-left {
                display: inline-block;
                margin: 0 10px;
                img {
                  width: 101px;
                }
              }
              // .chart {
              //   display: inline-block;
              //   border: 2px solid #77BEFF;
              //   width: 313px;
              //   height: 155px;
              //   border-radius: 6px;
              //   padding: 8px 5px 5px;
              //   margin-top: 15px;
              //   .child-item {
              //     display: inline-block;
              //     border: 2px solid #bbb;
              //     width: 70px;
              //     height: 70px;
              //     text-align: center;
              //     border-radius: 6px;
              //     // margin: 5px 2px;
              //     margin-left: 3px;
              //     margin-bottom: 3px;
              //     position: relative;
              //     color: #bbb;
              //     i {
              //       position: absolute;
              //       right: 4px;
              //       top: 4px;
              //       width: 12px;
              //       height: 12px;
              //       font-size: 10px;
              //       font-weight: bold;
              //       border: 1px solid #bbb;
              //       border-radius: 50%;
              //       line-height: 12px;
              //     }
              //     p {
              //       margin-top: 1px;
              //       font-size: 12px;
              //       width: 100%;
              //       overflow: hidden;
              //       text-overflow: ellipsis;
              //       white-space: nowrap;
              //     }
              //     .An {
              //       margin-top: 20px;
              //       font-size: 18px;
              //       font-weight: bold;
              //       span {
              //         font-size: 12px;
              //       }
              //     }
              //   }
              // }
              .device-params {
                float: right;
                width: calc(100% - 140px);
                margin-top: -5px;
                >div {
                  margin-bottom: 7px;
                  color: #333;
                  font-size: 13px;
                  p {
                    font-size: 13px;
                    &:last-child {
                      margin-top: 2px;
                    }
                  }
                  .params-t {
                    display: inline-block;
                    color: #178FFD;
                    border: 1px solid #178FFD;
                    padding: 0 8px;
                    font-size: 12px;
                    border-radius: 2px;
                    // margin-bottom: 5px;
                  }
                  // .time-t {
                  //   font-size: 10px;
                  // }
                }
              }
            }
            .card-bottom {
              border-top: 1px solid #E1E1E1;
              height: 30px;
              line-height: 30px;
              img {
                margin-right: 5px;
              }
              >span {
                border: 1px solid #1890FF;
                color: #1890FF;
                font-size: 12px;
                padding: 0px 5px;
                border-radius: 3px;
                margin-left: 10px;
              }

              ul {
                float: right;
                li {
                  display: inline-block;
                  line-height: 15px;
                  text-align: center;
                  margin-right: 5px;
                  span {
                    display: inline-block;
                    width: 10px;
                    height: 10px;
                    background-color: #bbb;
                    border-radius: 50%;
                  }
                  p {
                    font-size: 12px;
                    border: 1px solid #bbb;
                    color: #bbb;
                    width: 13px;
                    height: 13px;
                    line-height: 13px;
                    border-radius: 50%;
                  }
                }
              }
            }
          }
          .out-card {
            color: #aaa;
            h6 {
              .title {
                color: #bbb;
              }
              .u1 {
                color: #bbb;
                border-color: #bbb;
              }
              .title-right {
                color: #bbb;
              }
            }
            .chart-item {
              .device-params {
                >div {
                  color: #aaa;
                  .params-t {
                    color: #aaa;
                    border-color: #aaa;
                  }
                }
              }
            }
            .card-bottom {
              >span {
                color: #aaa;
                border-color: #aaa;
              }
              ul {
                li {
                  p {
                    color: #aaa;
                  }
                }
              }
            }
          }
        }

        .cardPage {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 50px;
          text-align: center;
          padding: 10px 0;
          box-sizing: border-box;
        }

        &.active {
          width: 100%;

          .cardList {
            height: 100%;
            width: 100%;
            overflow-x: hidden;
            overflow-y: auto;

            &>li {
              float: left;
              width: 20%;
              height: 240px;
            }
          }
        }
      }

      .overText {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

    }
  }
  .maskingRight{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0,0.4);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    .listsRight {
      position: absolute;
      right: 12px;
      top: 0;
      width: 740px;
      height: 100%;
      z-index: 9999;
      box-shadow: -2px 0 10px #ccc;
      background: #fff;

      &.component-slid-open {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        opacity: 1;
        animation: slid-open 0.5s ease;
      }

      &.component-slid-out {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        animation: slid-out 0.5s ease;
      }

      .messContainer {
        width: 100%;
        height: 100%;
        // padding-left: 10px;
        box-sizing: border-box;

        .cons {
          width: 100%;
          height: 100%;
          // background: #f3f3f3;
          // background: rgba(243,243,243,1);
        }
      }
    }
  }
  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
  }

  @keyframes slid-open {
    0% {
      transform: translateX(100%);
      opacity: 0;
    }

    100% {
      transform: translateX(0);
    }
  }

  @keyframes slid-out {
    0% {
      width: 600px;
      transform: translateX(0)
    }

    100% {
      transform: translateX(100%)
    }
  }
}
</style><style lang="scss">
.ControlDevice {
  .devcieContainer {
    position: relative;
    .query {
      // padding-left: 10px;

      .el-input {
        width: 220px;
        margin-right: 10px;
        .el-input__inner {
          line-height: 36px;
          height: 36px;
          // border:none;
          // outline: none;
        }
      }

      .el-select {
        width: 170px;
        margin-right: 10px;

        .el-input {
          width: 170px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
            // border:none;
            // outline: none;
          }
        }
      }
    }

    .el-loading-mask {
      background-color: unset;
    }

    .treeAside {
      position: absolute;
      width: 300px;
      height: 100%;
      padding: 0px 10px 10px 10px;
      left: 0;
      top: 0;
      box-sizing: border-box;

      .treeTop {
        width: 280px;
        position: absolute;
        height: 40px;
        line-height: 40px;
        font-size: 0;
        font-weight: bold;
        top: 15px;
        z-index: 10;
        // background: #fff;
        padding-left: 20px;
        box-sizing: border-box;

        .treeTopTitle {
          margin-right: 115px;
          // width: 500px;
          font-size: 18px;
          color: #333;
        }

        .el-button {
          margin-left: -24px;
        }

        .complete {
          margin-left: 10px;
        }
      }

      .treeBox {
        overflow: hidden;
        height: calc(100% - 15px);
        border: 1px solid #ebeef5;
        padding: 40px 10px 10px;
        box-sizing: border-box;
        background: #fff;
        margin-top: 15px;
      }

      .tree {
        height: 100%;
        overflow: auto;

        .el-tree-node__content {
          height: 40px;
        }

        .custom-tree-node {
          height: 40px;
          line-height: 40px;
          width: 100%;

          .treeLabel {
            font-size: 14px;
            display: inline-block;
            width: 130px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .treeBtn {
            float: right;

            .el-button {
              margin-left: 0;
            }
          }
        }
      }
    }
  }

  .el-breadcrumb {
    display: inline-block;
    padding: 0;
    font-family: AlibabaPuHuiTi-Medium;
  }

  .el-breadcrumb__inner a,
  .el-breadcrumb__inner.is-link {
    color: #7A7D81;
    font-size: 16px;
    font-weight: 500;
  }

  .el-breadcrumb__separator {
    font-size: 16px;
    color: #7A7D81;
    margin: 0 5px;
    font-weight: 500;
  }

  .el-breadcrumb__inner {
    font-size: 16px;
    color: #7A7D81 !important;
    font-weight: 500 !important;
  }
  .dialog-box {
    padding: 20px;
    li {
      display: inline-block;
      width: 187px;
      height: 168px;
      margin-right: 10px;
      margin-bottom: 10px;
      background-color: #fff;
      box-shadow: 0px 2px 8px 0px rgba(127, 127, 127, 0.29);
      border-radius: 6px;
      h6 {
        border-bottom: 1px solid #E1E1E1;
        width: 90%;
        height: 30px;
        line-height: 30px;
        margin: 0 auto;
        cursor: pointer;
        .edit-icon {
          float: right;
          font-size: 16px;
          margin-top: 8px;
          color: #1890FF;
        }
      }
      .eye-switch {
        // border: 1px solid red;
        width: 90%;
        margin: 5px auto;
        position: relative;
        .action-box {
          // height: 10px;
          display: inline-block;
          >i {
            font-size: 18px;
          }
          .eye {
            vertical-align: top;
          //   position: absolute;
          //   top: 0px;
          //   left: 0px;
          }
        }
        .switch-box {
          float: right;
          position: relative;
          .switch-text {
            font-size: 12px;
            position: absolute;
            top: 2px;
            left: 18px;
            color: #fff;
          }
          .el-switch__label {
            position: absolute;
            z-index: 9;
            color: #fff;
            display: none;
          }
          .el-switch__label.is-active {
            display: inline-block;
          }
          .el-switch__label--left {
            top: 0px;
            left: 17px;
          }
          .el-switch__label--right {
            top: -1px;
            left: -6px;
          }
        }
      }
      .set-bottom {
        color: #1890FF;
        position: relative;
        top: 14px;
        text-align: center;
        font-size: 14px;
        h4 {
          width: 50px;
          background-color: #fff;
          position: absolute;
          top: -10px;
          left: 50%;
          margin-left: -25px;
          font-size: 12px;
          color: #666;
        }
        .a-box {
          width: 144px;
          height: 58px;
          line-height: 58px;
          border: 1px solid #bbb;
          font-size: 28px;
          font-weight: bold;
          margin: 0 auto;
          border-radius: 4px;
          span {
            font-size: 12px;
          }
        }
      }
      .el-switch__core {
        // width: 36px!important;
        height: 18px;
        &:after {
          width: 14px;
          height: 14px;
        }
      }
      .el-switch.is-checked .el-switch__core::after {
        margin-left: -15px;
      }
    }
  }
  .edit-dialog {
    li {
      margin-top: 20px;
      .title {
        font-size: 14px;
        color: #333;
        display: inline-block;
        width: 80px;
      }
      .el-input {
        width: 300px;
        line-height: 40px;
        height: 40px;
      }
      .alarm-va {
        display: inline-block;
        width: 300px;
        vertical-align: top;
        color: #409EFF;
        >p {
          margin-bottom: 10px;
        }
        .el-input {
          width: 180px;
          line-height: 40px;
          height: 40px;
        }
        .equal {
          margin: 0 10px;
        }
        .el-input-number {
          line-height: 40px;
        }
        .el-input__inner {
          height: 42px;
          line-height: 40px;
        }
        .el-checkbox {
          color: #409EFF;
        }
      }
    }
  }
  .el-dialog__header {
    background-color: #1E2639;
    padding: 0;
    .el-dialog__title {
      font-size: 14px;
      color: #fff;
      line-height: 40px;
      margin-left: 22px;
    }
    .el-dialog__headerbtn {
      top: 13px;
      .el-dialog__close {
        color: #fff;
      }
    }
  }
 
}
</style>

